import { GridApi, GridReadyEvent } from "ag-grid-community";
import { action, makeObservable, observable } from "mobx";
import ModalContext from "../../../../../../../../core/modalZ/context/ModalContext";
import TrainingComponentsApi, {
  TrainingComponentsApi as ITrainingComponentsApi
} from "../../../../../../../../services/api/v2/TrainingComponents/TrainingComponents.api";
import TrainingModulesApi, {
  TrainingModulesApi as ITrainingModulesApi
} from "../../../../../../../../services/api/v2/trainingModules/TrainingModules.api";
import { ParseToJson } from "../../../../../../../../constants";

export interface IComponentsSummary {
  id: number;
  name: string;
  owner: string;
}

export class AddTrainingComponentsTrainingModulesModel {
  organisationId: number;
  projectId: number;
  componentsProvider: ITrainingComponentsApi;
  trainingComponentsProvider: ITrainingComponentsApi;
  trainingModulesProvider: ITrainingModulesApi;
  @observable.ref selectedComponents: number[];
  @observable.ref components: FP.Entities.ITrainingComponentSummary[];
  @observable isLoading: boolean = true;
  gridApi: GridApi;
  @observable searchText: string;
  trainingModulesIds: number[];
  @observable.ref assignedComponentsIds: number[] = [];
  onAssignSuccess: (selectedComponents: number) => void;

  constructor(
    organisationId: number,
    projectId: number,
    trainingModulesIds: number[],
    onAssignSuccess: (selectedComponents: number) => void,
    assignedComponentsIds?: number[]
  ) {
    makeObservable(this);
    this.organisationId = organisationId;
    this.projectId = projectId;
    this.componentsProvider = TrainingComponentsApi;
    this.trainingModulesProvider = TrainingModulesApi;
    this.trainingModulesIds = trainingModulesIds;
    this.onAssignSuccess = onAssignSuccess;
    this.assignedComponentsIds = assignedComponentsIds ?? [];
  }

  onMount = async () => {
    await this.loadAllComponents();
  };

  onUnmount = () => {};

  @action
  OnGridReady = (gridReadyEvent: GridReadyEvent): void => {
    this.gridApi = gridReadyEvent.api;
    this.gridApi.setFilterModel({});
  };

  loadAllComponents = async () => {
    let res = await this.componentsProvider.getGridData(this.organisationId, this.projectId);
    if (!res || res.isError) return;

    const payload = res.payload;

    this.setComponents(payload);
    this.isLoading = false;
  };

  @action
  setSearchText = (ev: React.FormEvent<HTMLInputElement>) => {
    this.searchText = ev.currentTarget.value;

    if (this.gridApi !== undefined) {
      this.gridApi.setGridOption("quickFilterText", this.searchText);
    }
  };

  addTrainingComponentsToTrainingModules = async selectedComponents => {
    ModalContext.hide();
    let res = await this.trainingModulesProvider.addBulkComponents(
      this.organisationId,
      this.projectId,
      this.trainingModulesIds,
      selectedComponents
    );
    if (!res || res.isError) return;
    this.onAssignSuccess(null);
    ModalContext.hide();
  };

  @action
  setComponents = (components: FP.Entities.ITrainingComponentSummary[]) => {
    this.components = components.map(e => {
      return { ...e, trainingModules: ParseToJson(e.trainingModules) };
    });
  };
}
